<div class="delete-alert-wrapper">
    <p class="alert-text">Are you sure you want to delete selected property?</p>
    <div class="alert-actions-wrapper">
        <button (click)="closeDialog()">Cancel</button>
        <!--<button class="delete-btn" (click)="deleteProperty(data.id)">Delete</button>-->
        <button class="delete-btn" (click)="deleteProperty()">Delete</button>
    </div>
</div>

